import { getRequest, postRequest } from 'utilities/service.utils';
import LocateService from './locate.service.context';
import createUrlBuilder from 'utilities/url.builder.utils';

export const getEssentials = async () => {
  const urlBuilder = createUrlBuilder(`sentinel/essential`).toString();

  return await getRequest(LocateService, urlBuilder);
};

export const getAuthorities = async (extent: any, organisationId: number) => {
  const data = { extent, organisationId: organisationId || null };
  const urlBuilder = createUrlBuilder(`sentinel/authorities`).toString();

  return await postRequest(LocateService, urlBuilder, data);
};

export const requestUserLinking = async (params: any) => {
  const urlBuilder = createUrlBuilder(
    `/sentinel/user/requestLinking`
  ).toString();
  return await postRequest(LocateService, urlBuilder, params);
};

export const verifyUserLinking = async (params: any) => {
  const urlBuilder = createUrlBuilder(
    `/sentinel/user/verifyLinking`
  ).toString();
  return await postRequest(LocateService, urlBuilder, params);
};

export const confirmUserLinking = async (params: any) => {
  const urlBuilder = createUrlBuilder(
    `/sentinel/user/confirmLinking`
  ).toString();
  return await postRequest(LocateService, urlBuilder, params);
};

export const setEmailLinking = async (params: any) => {
  const urlBuilder = createUrlBuilder(`/sentinel/user/setEmailLink`).toString();
  return await postRequest(LocateService, urlBuilder, params);
};

export const importEnquiries = async (params: any) => {
  const urlBuilder = createUrlBuilder(
    `/sentinel/user/importEnquiries`
  ).toString();
  return await postRequest(LocateService, urlBuilder, params);
};

export const unlinkDBYD = async (params: any) => {
  const urlBuilder = createUrlBuilder(`/sentinel/user/unlink`).toString();
  return await postRequest(LocateService, urlBuilder, params);
};

export const createEnquiry = async (data: any) => {
  const urlBuilder = createUrlBuilder(`sentinel/enquiry/internal`).toString();

  return await postRequest(LocateService, urlBuilder, data);
};
